import React, { createContext, useContext, useState, ReactNode } from "react";
import { otherConfigOptionsAttributes } from "../../salescodeStudio/mandatoryConfigs/configSetupScreen/widget/configBottomBar";

// Type for context value
interface FeatureSelectionOptionsContextType {
  uiConfigOptionsProp?: otherConfigOptionsAttributes[];
  setUiConfigOptionsProp?: React.Dispatch<
    React.SetStateAction<otherConfigOptionsAttributes[]>
  >;
}

export const FeatureSelectionOptionsContext = createContext<FeatureSelectionOptionsContextType>({
  uiConfigOptionsProp: [],
  setUiConfigOptionsProp: () => {},
});